import { Injectable } from '@angular/core';
import { Capacitor } from '@capacitor/core';
import { DbTableDefinition } from 'src/app/_services/persistence/db-persistence/db-table-definition';

@Injectable({
  providedIn: 'root',
})
export class MaterialDemandDbTableDefinition extends DbTableDefinition {
  tableName = 'materialdemand';
  tableStructure = `(id BIGINT(20) PRIMARY KEY null,
      databag LONGTEXT,
      label TEXT,
      servicejobid BIGINT(20),
      servicejoblabel TEXT,
      demandstatus TEXT,
      demandnumber TEXT,
      demanddate DOUBLE,
      assignedemployeeid BIGINT(20),
      assignedemployeelabel TEXT,
      requestedbyemployeeid BIGINT(20),
      requestedbyemployeelabel TEXT
    );`;

  constructor() {
    super();
    // Add UpdateStatements to Map
    this.updateStatements.set(18, [
      `CREATE TABLE IF NOT EXISTS ${this.tableName}${this.tableStructure}`,
    ]);
    if (Capacitor.getPlatform() === 'web') {
      this.alterStatements.push({
        table: this.tableName,
        col: 'extid',
        type: 'VARCHAR(255)',
      });
    } else {
      this.updateStatements.set(19, [
        `ALTER TABLE ${this.tableName} ADD COLUMN extid VARCHAR(255);`,
      ]);
    }
  }
}
